import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { NewsletterService } from '../../../core/services/newsletter.service';
import { NewsletterSubscriber } from '../../../shared/models/system';

@Component({
  selector: 'app-newsletter-admin',
  standalone: true,
  imports: [CommonModule, FormsModule, TableModule, ToastModule, InputTextModule],
  providers: [MessageService],
  templateUrl: './newsletter-admin.html',
  styleUrls: ['./newsletter-admin.css']
})
export class NewsletterAdminComponent implements OnDestroy {
  list: NewsletterSubscriber[] = [];
  loading = true;
  first = 0;
  rows = 10;
  totalRecords = 0;
  search = '';
  private searchTimer: ReturnType<typeof setTimeout> | null = null;
  private requestSeq = 0;

  constructor(
    private service: NewsletterService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }

  scheduleServerLoad(): void {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.reloadFirst(), 350);
  }

  reloadFirst(): void {
    this.first = 0;
    this.load({ first: 0, rows: this.rows });
  }

  load(event?: TableLazyLoadEvent) {
    const seq = ++this.requestSeq;
    this.loading = true;
    const first = event?.first ?? this.first;
    const size = event?.rows || this.rows;
    this.first = first || 0;
    this.rows = size;
    const page = this.rows > 0 ? Math.floor(this.first / this.rows) : 0;

    this.service.list(page, this.rows, this.search).subscribe({
      next: (data) => {
        if (seq !== this.requestSeq) return;
        this.list = data?.content || [];
        this.totalRecords = data?.totalElements || 0;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        if (seq !== this.requestSeq) return;
        this.list = [];
        this.totalRecords = 0;
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo cargar la lista del Club.'
        });
        this.cdr.detectChanges();
      }
    });
  }
}
